//external imports
import React, { useState, useContext } from 'react'
import { useSelector } from 'react-redux'

//internal imports
import Button from 'components/common/button'
import { LanguageContext } from 'context/LanguageContext'
import { getCurrentCountry, countryCode } from 'utils/appUtils'

const TnpChange = ({ tncArr, handleConfirmLocationAtTNC }) => {
    const { strings } = useContext(LanguageContext)

    const [termsAccepted, setTermsAccepted] = useState(false)
    const [privacyAccepted, setPrivacyAccepted] = useState(false)
    const locationInStore = useSelector(state => state.location)
    const userInStore = useSelector(state => state.user)
    const userCountry = getCurrentCountry(locationInStore, userInStore)
    const caTerms = useSelector(state => state.configuration.getIn(['ca_terms_url']))
    const usTerms = useSelector(state => state.configuration.getIn(['us_terms_url']))
    const caPrivacy = useSelector(state => state.configuration.getIn(['ca_privacy_url']))
    const usPrivacy = useSelector(state => state.configuration.getIn(['us_privacy_url']))
    const termsLink =
        userCountry === countryCode.CA
            ? caTerms.split('?').shift() || strings.LINKS_canadaTermsAndConditions
            : usTerms.split('?').shift() || strings.LINKS_TermsAndConditions
    const privacyLink =
        userCountry === countryCode.CA
            ? caPrivacy.split('?').shift() || strings.LINKS_canadaPrivacyPolicy
            : usPrivacy.split('?').shift() || strings.LINKS_PrivacyPolicy

    const handleConfirm = () => {
        const termId = termsAccepted ? tncArr.find(t => t.type === 'terms') : null
        const privacyId = privacyAccepted ? tncArr.find(t => t.type === 'privacy') : null
        handleConfirmLocationAtTNC(termId, privacyId)
    }
    return (
        <div className={'tnpChange'}>
            <div>
                <h2>{strings.acceptNewTitle}</h2>
                <h4>{strings.acceptNewSubtitle}</h4>
            </div>
            <div>
                {tncArr.map(ele => {
                    if (ele.type === 'terms') {
                        return (
                            <div className="customCheck" key={ele.id}>
                                <input
                                    key={1}
                                    type="checkbox"
                                    name={'terms'}
                                    id={'terms'}
                                    value={'terms'}
                                    checked={termsAccepted}
                                    onChange={() => setTermsAccepted(!termsAccepted)}
                                    tabIndex="0"
                                    aria-label={'Yes, I accept the terms and conditions'}
                                />
                                <label htmlFor={'terms'} id="checkbox">
                                    <svg viewBox="0 0 100 100">
                                        <path
                                            className="box"
                                            d="M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"
                                        />
                                        <polyline
                                            className="check"
                                            points="25.5,53.5 39.5,67.5 72.5,34.5 "
                                        />
                                    </svg>
                                    <span>
                                        {strings.acceptTermMsg}{' '}
                                        <a
                                            href={termsLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={'checklink'}
                                        >
                                            <strong>{strings.termsAndConditions}</strong>
                                        </a>
                                    </span>
                                </label>
                            </div>
                        )
                    }
                    if (ele.type === 'privacy') {
                        return (
                            <div className="customCheck" key={ele.id}>
                                <input
                                    key={2}
                                    type="checkbox"
                                    name={'privacy'}
                                    id={'privacy'}
                                    value={'privacy'}
                                    checked={privacyAccepted}
                                    onChange={() => setPrivacyAccepted(!privacyAccepted)}
                                    tabIndex="0"
                                    aria-label={'Yes I accept the Privacy Policy'}
                                />
                                <label htmlFor={'privacy'} id="checkbox">
                                    <svg viewBox="0 0 100 100">
                                        <path
                                            className="box"
                                            d="M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"
                                        />
                                        <polyline
                                            className="check"
                                            points="25.5,53.5 39.5,67.5 72.5,34.5 "
                                        />
                                    </svg>
                                    <span>
                                        {strings.acceptTermMsg}{' '}
                                        <a
                                            href={privacyLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={'checklink'}
                                        >
                                            <strong>{strings.privacyLink}</strong>
                                        </a>
                                    </span>
                                </label>
                            </div>
                        )
                    }
                })}
            </div>
            <div>
                <Button
                    disabled={
                        tncArr.length > 1
                            ? !termsAccepted || !privacyAccepted
                            : tncArr.find(t => t.type === 'terms')
                              ? !termsAccepted
                              : !privacyAccepted
                    }
                    className={'confirm confirm-xl'}
                    onClick={handleConfirm}
                >
                    {strings.confirmLocationButton}
                </Button>
            </div>
        </div>
    )
}

export default TnpChange
